import React from 'react'


export default class Notes extends React.PureComponent {
	constructor(props){
		super(props)
		this.state = {
			Note: props.Note
		}
	}
	render () {
		return (
			<div className="NoteContents">
				{this.state.Note}
			</div>
		)
	}
}